module.exports = __webpack_public_path__ + "assets/certificate_pdf/Microsoft CertifiedAzure AI Fundamentals_Microsoft_H913-8282_20210730.47c57a05.pdf";